import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=72eca723&scoped=true&"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js&"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundComponent.vue?vue&type=style&index=0&id=72eca723&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eca723",
  null
  
)

export default component.exports